import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { BlogService, BlogArticle } from './blog.service';
import { SeoService } from '../services/seo.service';

@Component({
  selector: 'app-blog',
  standalone: true,
  imports: [],
  templateUrl: './blog.component.html',
  styleUrl: './blog.component.scss'
})
export class BlogComponent implements OnInit {
  articles: BlogArticle[] = [];
  loading = true;

  constructor(
    private blogService: BlogService,
    private router: Router,
    private seo: SeoService
  ) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Blog - Investiční články',
      description: 'Odborné články o investicích, ETF, dluhopisech, realitních fondech a finančním plánování od Aleše Hradila a Petry Novotné.',
      keywords: 'blog, investice, finanční gramotnost, ETF, dluhopisy, akcie, dividendy, investiční poradenství',
      url: '/blog'
    });

    this.blogService.getArticles().subscribe(articles => {
      this.articles = articles;
      this.loading = false;
    });
  }

  readMore(article: BlogArticle): void {
    this.router.navigate(['/blog', article.slug]);
  }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = '/assets/img/logo.svg';
  }

  onAuthorImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = '/assets/img/logo.svg';
  }
}
